var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { parse, stringify } from "qs";
import md5 from "md5";
import axios from "axios";
import { Base64 } from "js-base64";
function loadScript(url) {
  window.loadedScriptPromises = window.loadedScriptPromises || {};
  if (window.loadedScriptPromises[url]) {
    return window.loadedScriptPromises[url];
  }
  window.loadedScriptPromises[url] = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
    script.onload = function() {
      script.onload = null;
      resolve({
        code: 1,
        msg: "script load success!"
      });
    };
    script.onerror = function() {
      reject({
        code: -1,
        msg: "script load error!"
      });
    };
  });
  return window.loadedScriptPromises[url];
}
function pick(obj, keys) {
  return keys.reduce(function(result, key) {
    if (obj[key]) {
      result[key] = obj[key];
    }
    return result;
  }, {});
}
function omit(obj, keys) {
  let result = {}, key;
  for (key in obj) {
    if (keys.indexOf(key) == -1)
      result[key] = obj[key];
  }
  return result;
}
function uniq(list, key) {
  const _map = {};
  const list_temp = [...list];
  for (let i = 0; i < list_temp.length; i++) {
    const match = list_temp[i][key];
    if (_map[match]) {
      list_temp.splice(i, 1, "");
    }
    _map[match] = true;
  }
  return list_temp.filter((v) => !!v);
}
const sortByRule = (list, key, rule) => {
  if (!Array.isArray(list) || !Array.isArray(rule))
    return;
  const result = [];
  rule.map((ret) => {
    result.push(...list.filter((v) => v[key] === ret));
  });
  result.push(...list.filter((v) => !v[key] || rule.indexOf(v[key]) === -1));
  return result;
};
const sortByRule$1 = sortByRule;
const versionfunegt = (appVer = "", standardVer = "") => {
  if (!appVer || !standardVer)
    return false;
  let appVerArr = appVer.split(".").map((item) => +item);
  let standardVerArr = standardVer.split(".").map((item) => +item);
  if (appVerArr[0] !== standardVerArr[0]) {
    return appVerArr[0] > standardVerArr[0];
  } else {
    if (appVerArr[1] !== standardVerArr[1]) {
      return appVerArr[1] > standardVerArr[1];
    } else {
      return appVerArr[2] >= standardVerArr[2];
    }
  }
};
const versionfunegt$1 = versionfunegt;
function typeMatch({ url, type }) {
  try {
    let allowType = ["search", "hash"];
    if (allowType.includes(type.toLowerCase())) {
      let urlObj;
      try {
        urlObj = new URL(url || location.href);
      } catch (e) {
        let isServer2 = typeof window === "undefined";
        if (!isServer2) {
          urlObj = document.createElement("a");
          urlObj.href = url || location.href;
        }
      }
      let targetHead = "";
      if (type === "search") {
        targetHead = "?";
      } else if (type === "hash") {
        if (urlObj[type] && urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)) {
          urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)[0];
        } else {
          targetHead = "#/?";
        }
      }
      let targetString = urlObj[type].replace(targetHead, "");
      let targetObj;
      try {
        targetObj = parse(targetString) || {};
      } catch (error) {
        targetObj = {};
      }
      return { urlObj, targetObj, targetHead };
    } else {
      return false;
    }
  } catch (err) {
    console.error(err);
  }
}
function addUrlParams({ url, type = "search", params }) {
  let match = typeMatch({ url, type });
  if (match) {
    let { urlObj, targetObj, targetHead } = typeMatch({ url, type });
    let finalParamsStr = stringify(Object.assign(targetObj, params));
    urlObj[type] = `${targetHead}${finalParamsStr}`;
    return urlObj.href;
  } else {
    return url;
  }
}
function getUrlParams({ url, type = "search", params = [] }) {
  let { targetObj } = typeMatch({ url, type });
  return pick(targetObj, params);
}
const getQueryString = (name, url) => {
  const reg = new RegExp(`(^|&?)${name}=([^&]*)(&|$)`);
  const r = (url || window.location.search.substr(1)).match(reg);
  if (r != null)
    return unescape(r[2]);
  return null;
};
const getQueryString$1 = getQueryString;
const updateQueryStringParameter = (url, key, value) => {
  if (typeof value === "undefined") {
    return url;
  }
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, "i");
  const separator = url.indexOf("?") !== -1 ? "&" : "?";
  if (url.match(re)) {
    return url.replace(re, `$1${key}=${value}$2`);
  } else {
    return `${url + separator + key}=${value}`;
  }
};
const updateQueryStringParameter$1 = updateQueryStringParameter;
const addQueryToUrl = (url, querys) => {
  if (!url || !querys)
    return url;
  for (const key in querys) {
    url = updateQueryStringParameter$1(url, key, querys[key]);
  }
  return url;
};
const addQueryToUrl$1 = addQueryToUrl;
function getPlatform() {
  const ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : navigator.userAgent;
  const isServer2 = typeof window === "undefined";
  const PickYxlInfoString = function(pickdata, filter) {
    if (!isServer2 && window && window.YXL_INFO && typeof pickdata == "string") {
      let data = window.YXL_INFO[pickdata];
      if (typeof data === "function") {
        data = window.YXL_INFO[pickdata]();
      }
      if (filter && typeof filter == "function") {
        return filter(data);
      }
      return data;
    } else {
      return void 0;
    }
  };
  const fullTypeJudge = function(Rex, targerStringLikeUA, { type, isTargetApp, useWierdWay = true } = { useWierdWay: true }) {
    if (isServer2) {
      useWierdWay = false;
    }
    const regExp = Rex;
    const uaMatch = runRex(regExp, targerStringLikeUA);
    const YxlInfoFilterMap = {
      app: (app) => {
        let appRegExName;
        switch (app) {
          case "\u58F9\u5FC3\u7406":
            appRegExName = "yixinliApp";
            break;
          default:
            appRegExName = "n0th1ng MaTch";
            break;
        }
        return appRegExName;
      },
      system: (system) => {
        const isiOS2 = /iOS|ios/g.test(system);
        return isiOS2 ? "iOS" : "Android";
      },
      model: null,
      version: (version) => {
        if (isTargetApp) {
          return version;
        } else {
          return "0.0.0";
        }
      },
      fullscreen: (tof) => !!tof
    };
    const clientNavagitorTry = {
      app: () => {
        if (!isServer2) {
          const { _platform: searchPlatform } = getUrlParams({
            url: location.href,
            params: ["_platform"]
          }) || "";
          const { _platform: hashPlatform } = getUrlParams({
            url: location.href,
            type: "hash",
            params: ["_platform"]
          }) || "";
          if (searchPlatform || hashPlatform) {
            return true;
          } else {
            return false;
          }
        }
      },
      version: () => {
        if (!isServer2 && isTargetApp) {
          const { _version: searchVersion } = getUrlParams({
            url: location.href,
            params: ["_version"]
          }) || "";
          const { _version: hashVersion } = getUrlParams({
            url: location.href,
            type: "hash",
            params: ["_version"]
          }) || "";
          if (searchVersion) {
            return searchVersion;
          } else if (hashVersion) {
            return hashVersion;
          } else {
            return false;
          }
        }
      }
    };
    const InfoString = PickYxlInfoString(type, YxlInfoFilterMap[type]);
    const wierdWaysToComfirm = (type2) => {
      const canTry = clientNavagitorTry[type2];
      if (canTry && useWierdWay) {
        const wierdTryResult = canTry(Rex, targerStringLikeUA);
        console.log("wierdTryResult", wierdTryResult);
        return wierdTryResult;
      } else {
        return false;
      }
    };
    const wierdWays = wierdWaysToComfirm(type);
    try {
      if (InfoString) {
        if (type == "version") {
          console.log("------------------InfoString", regExp.toString(), InfoString);
          return `${InfoString}`;
        } else {
          console.log("------------------InfoString", regExp.toString(), runRex(regExp, InfoString));
          return runRex(regExp, InfoString);
        }
      } else if (uaMatch) {
        console.log("------------------", Rex.toString(), uaMatch, wierdWays);
        if (type == "version") {
          if (uaMatch)
            return targerStringLikeUA.match(regExp)[0].split(";")[1];
        } else {
          return uaMatch;
        }
      } else if (wierdWays) {
        return wierdWays;
      } else {
        return false;
      }
    } catch (e) {
      console.error(
        `Error@getPlaftorm:${e.toString()}
ParamsRex:${Rex.toString()}, targerStringLikeUA: ${targerStringLikeUA}, type: ${type}, isTargetApp: ${isTargetApp}, useWierdWay: ${useWierdWay}`
      );
    }
  };
  let runRex = function(Rex, targetString) {
    if (Rex.test) {
      return Rex.test(targetString);
    } else {
      return false;
    }
  };
  const iPadOS13Up = isServer2 ? false : navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  const isWindowsPhone = fullTypeJudge(/(?:Windows Phone)/, ua), isSymbian = fullTypeJudge(/(?:SymbianOS)/, ua) || isWindowsPhone, isAndroid = fullTypeJudge(/(?:Android)/, ua, { type: "system" }), isiOS = fullTypeJudge(/(?:iOS)/, ua, { type: "system" }), isFireFox = fullTypeJudge(/(?:FireFox)/, ua), isChrome = fullTypeJudge(/(?:Chrome|CriOS)/, ua), isWechat = fullTypeJudge(/(?:MicroMessenger)/, ua), isiPad = fullTypeJudge(/(?:iPad)/, ua, { type: "model" }) || iPadOS13Up, isiPhone = fullTypeJudge(/(?:iPhone)/, ua, { type: "model" }), isTablet = fullTypeJudge(/(?:Tablet|PlayBook)/, ua) || isiPad || isAndroid && !fullTypeJudge(/(?:Mobile)/, ua) || isFireFox && fullTypeJudge(/(?:Tablet)/, ua), isPc = !isiPhone && !isAndroid && !isSymbian && !isiPad, isMobile = !isPc, isZiXunApp = fullTypeJudge(/(?:yixinliConsultationApp)/, ua, {
    type: "app",
    useWierdWay: false
  }), isYixinliApp = fullTypeJudge(/(?:yixinliApp)/, ua, {
    type: "app",
    useWierdWay: false
  }), isMuseApp = fullTypeJudge(/(?:muse)/, ua, {
    type: "app",
    useWierdWay: false
  }), isCeShiApp = fullTypeJudge(/(?:XinLiCeShiApp)/, ua, {
    type: "app",
    useWierdWay: false
  }), yixinliAPPVersion = fullTypeJudge(/^([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/, ua, {
    type: "version",
    isTargetApp: isYixinliApp,
    useWierdWay: false
  }), museAPPVersion = fullTypeJudge(/muse;*.*.*/i, ua, {
    type: "version",
    isTargetApp: isMuseApp,
    useWierdWay: false
  }), zixunAppVersion = fullTypeJudge(/yixinliConsultationApp;*.*.*/i, ua, {
    type: "version",
    isTargetApp: isZiXunApp,
    useWierdWay: false
  }), isBaiduminiapp = fullTypeJudge(/(?:swan-baiduboxapp)/, ua), isZiXunShiApp = fullTypeJudge(/(?:(Android|iOS)-Counselor)/, ua), isWxmp = fullTypeJudge(/miniProgram/, ua), isWeibo = fullTypeJudge(/(weibo).*weibo__([\d.]+)/i, ua);
  const result = {
    isAndroid,
    isiOS,
    isPc,
    isMobile,
    isTablet,
    isiPhone,
    isiPad,
    isChrome,
    isWechat,
    isYixinliApp,
    isMuseApp,
    isCeShiApp,
    isZiXunApp,
    isZiXunShiApp,
    isWxmp,
    isBaiduminiapp,
    yixinliAPPVersion,
    museAPPVersion,
    zixunAppVersion,
    isWeibo
  };
  return result;
}
const BRIDGERESOLVE = "_bridgeResolve";
class Bridge {
  constructor(options = "") {
    this.tokenStringify = "";
    this.version = "0.1";
    this.platform = getPlatform();
    if (options && !options.disInitAppHook) {
      this.AppHookInit();
    }
    this.ready = null;
    if (options && options.methods && options.methods.length) {
      const methods = options.methods;
      for (let i = 0; i < methods.length; i++) {
        this.MethodCall(methods[i]);
      }
    }
  }
  _init() {
  }
  add(options) {
    let methods;
    if (options && options.methods && options.methods.length) {
      methods = options.methods;
    } else if (Array.isArray(options)) {
      methods = options;
    } else if (typeof options === "object") {
      methods = [options];
    }
    if (methods) {
      for (let i = 0; i < methods.length; i++) {
        this.MethodCall(methods[i]);
      }
    }
  }
  MethodCall(obj) {
    const ERROR_TITLE = "[Bridge.js] error : ";
    const methodName = obj.method;
    try {
      if (!methodName)
        throw `${ERROR_TITLE} method undefined`;
      if (!obj.callback)
        throw `${ERROR_TITLE} callback undefined`;
      window[methodName] = (param = "{}") => {
        const formatedParams = JSON.parse(param);
        obj.callback(formatedParams);
        const bridgeResolve = window[methodName][BRIDGERESOLVE];
        if (typeof bridgeResolve === "function") {
          bridgeResolve(formatedParams);
          window[methodName][BRIDGERESOLVE] = null;
          console.log(`\u91CA\u653E${methodName}\u7684resolve`);
        }
        if (Object.prototype.toString.call(bridgeResolve) === "[object Array]") {
          bridgeResolve.forEach((resolve) => {
            resolve(formatedParams);
          });
          window[methodName][BRIDGERESOLVE] = [];
          console.log(`\u91CA\u653EgetTokenArr\u7684resolve`);
        }
      };
    } catch (err) {
      console.error(`${ERROR_TITLE} MethodCall register failed`, err);
    }
  }
  _callIos(callName, options = {}) {
    console.log("@ _callIos", options);
    try {
      options = options ? JSON.stringify(options) : null;
      window.webkit.messageHandlers[callName].postMessage(options);
    } catch (err) {
      console.log(err);
    }
  }
  _callAndroid(callName, options = {}) {
    console.log("@ _callAndroid", options);
    try {
      options = options ? window.JSON.stringify(options) : "";
      const uri = `jsbridge://bridege/${callName}?${options}`;
      window.prompt(uri, "");
    } catch (err) {
      console.error(err);
    }
  }
  call(callName = "", options = {}) {
    const system = this.platform.isiPhone || this.platform.isiPad ? "Ios" : "Android";
    const callbackName = options.callbackName;
    try {
      const platform = getPlatform();
      if (!platform.isYixinliApp && !platform.isMuseApp && !platform.isCeShiApp && !platform.isZiXunApp && window.navigator.userAgent.indexOf("yixinli") === -1) {
        typeof window.monitor === "object" && typeof window.monitor.stat === "function" && window.monitor.stat({
          title: "\u5728\u975Eapp\u73AF\u5883\u8C03\u7528bridge\uFF01\uFF01\uFF01\uFF01",
          level: "error",
          logType: "JSError",
          code: 599
        });
      }
    } catch (e) {
      console.error("bridge \u5F02\u5E38\u65E5\u5FD7\u4E0A\u62A5\u5931\u8D25", e);
    }
    return new Promise((resolve) => {
      if (callbackName && typeof window[callbackName] === "function") {
        if (callName === "getToken") {
          let resolveArr = window[callbackName][BRIDGERESOLVE];
          if (resolveArr) {
            resolveArr.push(resolve);
          } else {
            resolveArr = [resolve];
            window[callbackName][BRIDGERESOLVE] = resolveArr;
          }
        } else {
          window[callbackName][BRIDGERESOLVE] = resolve;
        }
      } else {
        resolve();
      }
      this[`_call${system}`](callName, options);
    });
  }
  removeMethods() {
    if (this.ots && this.ots.methods && this.ots.methods.length > 0) {
      for (let i = 0; i < this.ots.methods.length; i++) {
        const obj = this.ots.methods[i];
        window[obj.method] = null;
      }
    }
  }
  AppHookInit() {
    console.log("\u521D\u59CB\u5316APP\u4E8B\u4EF6");
    const codeEventMap = {
      10001: "appShow",
      "10002_0": "appPayDoneFail",
      "10002_1": "appPayDoneSuccess",
      10003: "appWebviewShow",
      10004: "appWebviewHide"
    };
    const eventFactory = function(code) {
      const eventName = codeEventMap[code];
      return new Event(eventName);
    };
    window.yxlAppCustomEvent = {};
    for (const key in codeEventMap) {
      window.yxlAppCustomEvent[key] = eventFactory(key);
    }
    window.appBecomeActiveStatus = function(optionString) {
      const res = JSON.parse(optionString);
      console.log(
        "\u6D3E\u53D1App\u4E8B\u4EF6",
        res.code,
        `Useage: window.addEventListener(${codeEventMap[res.code]})`
      );
      switch (+res.code) {
        case 10002:
          if (res.data.status === "paySuccess") {
            window.dispatchEvent(window.yxlAppCustomEvent[`10002_1`]);
          } else {
            window.dispatchEvent(window.yxlAppCustomEvent[`10002_0`]);
          }
          break;
        default:
          window.dispatchEvent(window.yxlAppCustomEvent[+res.code]);
          break;
      }
    };
  }
}
try {
  if (typeof window !== "undefined") {
    window.Bridge = Bridge;
  }
} catch (e) {
  console.log(e);
}
const createHttpServer = () => {
  const _http = axios.create({ withCredentials: true });
  const { isYixinliApp, isZiXunApp } = getPlatform();
  if (isYixinliApp || isZiXunApp) {
    const getToken = () => new Promise((resolve) => {
      const callbackName = `frontend_lib_axios_getToken${+new Date()}`;
      const bridge = new Bridge({
        methods: [
          {
            method: callbackName,
            callback: (obj) => {
              if (typeof obj === "object" && !!obj.token) {
                resolve(obj.token);
              } else {
                resolve("");
              }
            }
          }
        ]
      });
      bridge.call("getToken", {
        callbackName
      });
    });
    _http.formatEnvInterceptor = _http.interceptors.request.use((res) => {
      if (isYixinliApp || isZiXunApp) {
        return getToken().then((token) => {
          if (res.url.indexOf("?") === -1) {
            res.url += `?token=${token}`;
          } else {
            res.url += `&token=${token}`;
          }
          return Promise.resolve(res);
        });
      }
    });
  }
  return _http;
};
const createHttpServer$1 = createHttpServer;
const mockPrefix = "yapi.xinli001.com/mock/";
const mockMatch = [
  { from: "m", to: "22" },
  { from: "yiapp", to: "9" },
  { from: "yiapi", to: "20" }
];
const isServer = typeof window === "undefined";
const transfromUrlToMock = (url) => {
  if (url.indexOf("http") !== 0) {
    const protocol = isServer ? "https:" : window.location.protocol;
    url = protocol + url;
  }
  const urlObejct = new URL(url);
  const hostPre = urlObejct.host.split(".")[0];
  const matchHost = mockMatch.find((v) => hostPre.indexOf(v.from) === 0);
  if (!matchHost)
    return url;
  const mockUrl = url.replace(urlObejct.host, mockPrefix + matchHost.to);
  return mockUrl;
};
const mergeMockInterceptor = (_http, yxlConfig) => {
  if (!_http || !yxlConfig)
    return;
  const { useMock, env } = yxlConfig;
  if (env === "")
    return;
  if (!useMock && !Array.isArray(useMock))
    return;
  const isMatch = (url) => {
    if (useMock === true)
      return true;
    return useMock.find((v) => url.match(new RegExp(v)));
  };
  _http.mockInterceptor = _http.interceptors.request.use((res) => {
    const { url } = res;
    if (!isMatch(url))
      return res;
    res.url = transfromUrlToMock(res.url);
    console.log(`mockTo`, res.url);
    return res;
  });
  return _http.mockInterceptor;
};
const axiosMock = {
  transfromUrlToMock,
  mergeMockInterceptor
};
function baiduStat(id = "d64469e9d7bdbf03af6f074dffe7f9b5") {
  const platform = getPlatform();
  const isApp = platform.isYixinliApp || platform.isCeShiApp || platform.isZiXunApp;
  if (isApp) {
    return;
  }
  (function() {
    const hm = document.createElement("script");
    hm.src = `https://hm.baidu.com/hm.js?${id}`;
    const s2 = document.getElementsByTagName("script")[0];
    s2.parentNode.insertBefore(hm, s2);
  })();
  const bp = document.createElement("script");
  const curProtocol = window.location.protocol.split(":")[0];
  if (curProtocol === "https") {
    bp.src = "https://zz.bdstatic.com/linksubmit/push.js";
  } else {
    bp.src = "http://push.zhanzhang.baidu.com/push.js";
  }
  const s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(bp, s);
}
const loadedStyle = [];
function loadStyle(href) {
  return new Promise((resolve) => {
    if (loadedStyle.includes(href)) {
      resolve({
        code: 1,
        msg: "this style was loaded"
      });
    }
    const styleEl = document.createElement("link");
    styleEl.setAttribute("rel", "stylesheet");
    styleEl.setAttribute("href", href);
    document.head.appendChild(styleEl);
    styleEl.onload = function() {
      loadedStyle.push(href);
      resolve({
        code: 1,
        msg: "style load success!"
      });
    };
  });
}
function getRequestSign(params = {}, apiSecret = "") {
  const apiSecretMap = {
    android: "910676770dfc5c34d32e250ea3e91049",
    ios: "6767790dfc5c34d32e250ea3e9104910",
    m: "49da2fb42b5655d69f9449ca2fe30e40",
    pc: "9a9e2bc951b8b9ece1581cc2e78e240d"
  };
  const apiSecret2 = apiSecret ? apiSecret : apiSecretMap[params._platform || "ios"];
  const timestamp = new Date().getTime();
  const defaultParams = {
    timestamp
  };
  params = Object.assign(defaultParams, params);
  if (params["timestamp"]) {
    params = omit(params, "timestamp");
  }
  const keys = Object.keys(params).sort();
  let paramsStr = "";
  keys.map((key) => {
    paramsStr = `${paramsStr}${key}=${params[key]},`;
  });
  paramsStr = `${paramsStr}${timestamp}${apiSecret2}`;
  const sign = md5(paramsStr);
  params.timestamp = timestamp;
  return { sign, params };
}
function getRunningEnv() {
  let WEBPACK_DEV;
  try {
    WEBPACK_DEV = WEBPACK_DEV || false;
  } catch (error) {
    console.log(error);
  }
  const result = {};
  const env = location.host.split(".")[0].match(/(qc|box)[0-9]+/g);
  if (!!env || WEBPACK_DEV) {
    result.isDev = 1;
    result.env = env.length > 0 ? env[0] : "";
  } else {
    result.isDev = 0;
    result.env = "";
  }
  return result;
}
function getEnvHost(str) {
  const _getRunningEnv = getRunningEnv();
  const env = _getRunningEnv.env;
  let result = str;
  if (env) {
    result = str.replace(/\./, `-${env}.`);
  }
  return result;
}
function isIOS9() {
  const getOsv = function getOsv2() {
    const reg = /OS ((\d+_?){2,3})\s/;
    if (navigator.userAgent.match(/iPad/i) || navigator.platform.match(/iPad/i) || navigator.userAgent.match(/iP(hone|od)/i) || navigator.platform.match(/iP(hone|od)/i)) {
      const _osv = reg.exec(navigator.userAgent);
      if (_osv.length > 0) {
        return _osv[0].replace("OS", "").replace("os", "").replace(/\s+/g, "").replace(/_/g, ".");
      }
    }
    return "";
  };
  const osv = getOsv();
  const osvArr = osv.split(".");
  if (osvArr && osvArr.length > 0) {
    if (parseInt(osvArr[0]) <= 9) {
      return true;
    }
  }
  return false;
}
const isSpider = (ua = window.navigator.userAgent) => {
  try {
    return ua.toLowerCase().indexOf("spider") > -1 || ua.toLowerCase().indexOf("bingpreview") > -1 || ua.toLowerCase().indexOf("baiduboxapp") > -1 || ua.toLowerCase().indexOf("bot") > -1 || ua.toLowerCase().indexOf("nutch") > -1 || ua.toLowerCase().indexOf("yahoo") > -1 || ua.toLowerCase().indexOf("gougou") > -1 || ua.toLowerCase().indexOf("scooter") > -1 || ua.toLowerCase().indexOf("lilina") > -1 || ua.toLowerCase().indexOf("headlesschrome") > -1;
  } catch (e) {
    console.log(`isSpider`, e);
    return false;
  }
};
const isSpider$1 = isSpider;
const wxConfigOrigin = (json, origin, str, wechat = true, protocol = window.location.protocol) => {
  let originUpper = origin.toUpperCase();
  if (!/_ORIGIN$/.test(originUpper)) {
    originUpper += "_ORIGIN";
  }
  let className = "_warn", typeName = str;
  if (/_(warn|safe|risk)$/.test(str)) {
    const index = str.lastIndexOf("_");
    typeName = str.substring(index, 0);
    className = str.substr(index);
  }
  const platform = getPlatform();
  if (!platform.isWechat && wechat) {
    className = "_safe";
  }
  json = json["domain"][originUpper];
  if (json && json[typeName + className]) {
    return `${protocol}//${json[typeName + className]}`;
  } else {
    throw new Error(`wxConfigOrigin:Can't match any origin with ${origin}${str}`);
  }
};
const wxConfigOrigin$1 = wxConfigOrigin;
const handleExpiresStorage = (val, key, day = "", writable = false) => {
  const StorageObj = JSON.parse(localStorage.getItem(val));
  const StorageMap = /* @__PURE__ */ new Map();
  const curTime = Date.now();
  for (const key2 in StorageObj) {
    StorageMap.set(key2, StorageObj[key2]);
  }
  const keyValue = StorageMap.get(key);
  if (keyValue) {
    const interval = curTime - keyValue;
    if (interval < 0)
      return false;
  }
  if (writable) {
    localStorage.removeItem(val);
    StorageMap.set(key, curTime + day * 1e3 * 86400);
    const objFromMap = {};
    for (const [k, v] of StorageMap) {
      objFromMap[k] = v;
    }
    localStorage.setItem(val, JSON.stringify(objFromMap));
  }
  return true;
};
const handleExpiresStorage$1 = handleExpiresStorage;
const isCanHideNavigationBar = (platform = getPlatform()) => {
  const { isYixinliApp, yixinliAPPVersion, isZiXunApp, zixunAppVersion, isZiXunShiApp } = platform;
  const isYixinliAppVersionWork = isYixinliApp && versionfunegt$1(yixinliAPPVersion, "5.9.0");
  const isZiXunAppVersionWork = isZiXunApp && versionfunegt$1(zixunAppVersion, "4.0.0");
  return (isYixinliAppVersionWork || isZiXunAppVersionWork || isZiXunShiApp) && window.screen.height - document.documentElement.clientHeight < 50;
};
const isCanHideNavigationBar$1 = isCanHideNavigationBar;
const getStatusBarHeight = () => {
  const { isAndroid, isYixinliApp, isCeShiApp, isZiXunApp } = getPlatform();
  return new Promise((resolve, reject) => {
    if (!isYixinliApp && !isCeShiApp && !isZiXunApp) {
      return resolve(0);
    }
    try {
      const bridge = new Bridge({
        methods: [
          {
            method: "areaListHasNotch",
            callback: (obj) => {
              const { hasNotch, notchHeight } = obj;
              const statusBarHeight = notchHeight && window.devicePixelRatio ? notchHeight / window.devicePixelRatio | 0 : hasNotch === 1 || hasNotch === true ? isAndroid ? 35 : 40 : 20;
              resolve(statusBarHeight);
            }
          }
        ]
      });
      bridge.call("hasNotch", {
        callbackName: "areaListHasNotch"
      });
    } catch (e) {
      reject(e);
    }
  });
};
const getStatusBarHeight$1 = getStatusBarHeight;
const isDangerUrl = (host = window.location.hostname) => {
  const dangerUrls = [
    "xinli001.com",
    "xinli001.xin",
    "xinli001.cc",
    "xinli001.net",
    "pgxinli.com",
    "zixunshizhijia.com"
  ];
  const isProd = getRunningEnv().env === "";
  const isWechat = getPlatform().isWechat;
  if (!isProd || !isWechat)
    return false;
  let isDanger = false;
  for (let i = 0; i < dangerUrls.length; i++) {
    const url = dangerUrls[i];
    if (host.indexOf(url) > -1) {
      isDanger = true;
    }
  }
  return isDanger;
};
const isDangerUrl$1 = isDangerUrl;
const chunkArray = (data, length) => {
  const newArr = [];
  for (let i = 0; i < data.length; i += length) {
    newArr.push(data.slice(i, i + length));
  }
  return newArr;
};
const chunkArray$1 = chunkArray;
const broswerLoadedToDownloadApp = () => {
  const platform = getPlatform();
  if (platform.isYixinliApp)
    return;
  if (platform.isiPhone || platform.isiPad) {
    window.location.href = `https://apps.apple.com/app/apple-store/id994051627`;
  } else {
    const iframe = document.createElement("iframe");
    const src = "https://filecdn.xinli001.com/android_patch/yixinli.apk";
    iframe.src = src;
    iframe.style = `width:0;height:0;overflow:hidden;position: absolute;`;
    document.body.appendChild(iframe);
    setTimeout(() => document.body.removeChild(iframe), 2e3);
  }
};
const broswerLoadedToDownloadApp$1 = broswerLoadedToDownloadApp;
function debounce(action, idle) {
  let last = null;
  return function() {
    const ctx = this;
    const args = arguments;
    clearTimeout(last);
    last = setTimeout(function() {
      action.apply(ctx, args);
    }, idle);
  };
}
function throttle(fn, delay, mustRunDelay = 0) {
  let timer = null;
  let tStart;
  return function() {
    const context = this;
    const args = arguments;
    const tCurr = +new Date();
    clearTimeout(timer);
    if (!tStart) {
      tStart = tCurr;
    }
    if (mustRunDelay !== 0 && tCurr - tStart >= mustRunDelay) {
      fn.apply(context, args);
      tStart = tCurr;
    } else {
      timer = setTimeout(function() {
        fn.apply(context, args);
      }, delay);
    }
  };
}
function setCookie({ key, value, timeMinSec, Expired = "", domain = location.host }) {
  const exp = new Date();
  exp.setTime(exp.getTime() + timeMinSec);
  if (Expired) {
    document.cookie = `${key}=${escape(value)};expires=${Expired};path=/;domain=${domain};`;
  } else if (timeMinSec) {
    document.cookie = `${key}=${escape(
      value
    )};expires=${exp.toGMTString()};path=/;domain=${domain};`;
  }
}
function getCookie(key) {
  const name = `${key}=`;
  const cookieArray = document.cookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    const c = cookieArray[i].trim();
    if (c.indexOf(name) == 0)
      return c.substring(name.length, c.length);
  }
  return void 0;
}
function delCookie(key) {
  setCookie({
    key,
    value: "",
    Expired: new Date("Thu, 01 Jan 1970 00:00:00 GMT:")
  });
}
function isBase64(str) {
  if (str === "" || str.trim() === "") {
    return false;
  }
  try {
    return Base64.encodeURI(Base64.decode(str)) == str;
  } catch (err) {
    return false;
  }
}
const parseQueryVal = (val) => {
  return isBase64(val) ? Base64.decode(val) : decodeURIComponent(val);
};
const handleQueryVal = (val) => {
  return Base64.encodeURI(val);
};
function isIpUrl(ip) {
  const re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  if (re.test(ip)) {
    if (RegExp.$1 < 256 && RegExp.$2 < 256 && RegExp.$3 < 256 && RegExp.$4 < 256)
      return true;
  }
  return false;
}
const isWxAppWebview = () => {
  return window && window.__wxjs_environment === "miniprogram";
};
const isAliPayWebview = () => {
  return navigator && /AlipayClient/i.test(navigator.userAgent);
};
class Track {
  constructor({ globalParams = {}, customTrackConfig = {}, sensorsConfig } = {}) {
    this.runningEnv = getRunningEnv();
    this.platform = getPlatform();
    this.isSpider = isSpider$1();
    this.globalParams = globalParams;
    this._http = createHttpServer$1();
    let platform_type;
    if (this.isApp) {
      platform_type = "app\u7AEF";
    } else if (window && window.__wxjs_environment === "miniprogram") {
      platform_type = "\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\u7AEF";
    } else if (isAliPayWebview()) {
      platform_type = "\u652F\u4ED8\u5B9D\u5C0F\u7A0B\u5E8F\u7AEF";
    } else {
      platform_type = "\u7F51\u9875\u7AEF";
    }
    const isLocal = window.location.href.indexOf("localhost") > -1;
    const isIp = isIpUrl(window.location.hostname);
    const isDev = this.runningEnv.isDev || isLocal || isIp;
    this.isDev = isDev;
    console.log("\u795E\u7B56\uFF0CisDev: ", this.isDev);
    this.sensorsConfig = sensorsConfig || (isDev ? {
      project: "",
      abtestKey: "12EF873F39ADC26C2325F77E33614F73DCA41F1E"
    } : {
      project: "production",
      abtestKey: "FE01E606197BE842D4F240332C2BD4BBE81A803D"
    });
    this.initSDK(customTrackConfig);
    this.setGlobalParams({
      platform_type
    });
  }
  get isApp() {
    const { isYixinliApp } = this.platform;
    return isYixinliApp;
  }
  get isEnable() {
    const { yixinliAPPVersion, isYixinliApp } = this.platform;
    return isYixinliApp ? versionfunegt$1(yixinliAPPVersion, "8.0.0") : !this.isSpider;
  }
  init() {
    return this;
  }
  setGlobalParams(globalParams = {}) {
    if (!this.isEnable)
      return;
    this.loadJSPromise.then(() => {
      window.sensors.registerPage(globalParams);
    });
  }
  initSDK(customTrackConfig) {
    if (!this.isEnable)
      return;
    const server_url = `${window.location.protocol}//sdata.xinli001.com/sa?project=${this.sensorsConfig.project}`;
    this.loadJSPromise = loadScript(
      "//static.xinli001.com/frontend-lib/sensorsdata.min.js?_version=1.23.3"
    ).then(() => {
      window.sensors = window["sensorsDataAnalytic201505"];
      const config = __spreadValues({
        show_log: !!this.isDev,
        server_url,
        scrollmap: {
          collect_url: () => {
            console.log(`scroll map collect_url`, this.isCollectUrl);
            return this.isCollectWebStay;
          }
        },
        heatmap: {
          loadTimeout: 3e3,
          clickmap: "default",
          scroll_notice_map: "default",
          collect_tags: {
            div: true,
            li: true,
            img: true,
            svg: true,
            a: true,
            p: true,
            em: true,
            span: true
          },
          collect_element: (element_target) => {
            const result = element_target.getAttribute("sensors-disable") === "true" ? false : this.isCollectWebClick;
            return result;
          }
        },
        is_track_single_page: false,
        use_client_time: true,
        send_type: "beacon",
        app_js_bridge: this.isApp
      }, customTrackConfig);
      console.log(`\u795E\u7B56init:`, config);
      window.sensors.init(config);
    });
  }
  loadAbTest() {
    if (this.loadABtestJSPromise) {
      return this.loadABtestJSPromise;
    }
    this.loadABtestJSPromise = Promise.all([
      this.loadJSPromise,
      loadScript("//static.xinli001.com/frontend-lib/abtest.min.js")
    ]).then(() => {
      const _abtest = window.sensors.use("SensorsABTest", {
        url: `${window.location.protocol}//abtest-tx-beijing-01.saas.sensorsdata.cn/api/v2/abtest/online/results?project-key=${this.sensorsConfig.abtestKey}`,
        multilink: {
          timeout: 500,
          pass_params: true
        }
      });
      this._abtest = _abtest;
    });
    return this.loadABtestJSPromise;
  }
  send(name, properties) {
    if (!this.isEnable)
      return;
    this.loadJSPromise.then(() => {
      window.sensors.track(name, properties || {});
    });
  }
  identify(id, properties) {
    if (!this.isEnable)
      return;
    this.loadJSPromise.then(() => {
      try {
        window.sensors.login(id);
        if (properties) {
          window.sensors.setProfile(properties);
        }
      } catch (error) {
        console.error(error);
      }
    });
  }
  login(id) {
    if (!this.isEnable)
      return;
    this.loadJSPromise.then(() => {
      try {
        window.sensors.login(id);
      } catch (error) {
        console.error(error);
      }
    });
  }
  _getUserInfo() {
    const pre = this.runningEnv.env ? `-${this.runningEnv.env}` : "";
    return new Promise((resolve) => {
      this._http.get(`//m${pre}.xinli001.com/ajax/get-user-header`).then((res) => {
        const { code, data } = res.data;
        if (code === 0) {
          resolve(data);
        }
        resolve(null);
      }).catch(() => resolve(null));
    });
  }
  _fetchSensorsCustomWhiteCache(token) {
    if (!this._fetchSensorsCustomWhiteFetchPromise) {
      const pre = this.runningEnv.env ? `-${this.runningEnv.env}` : "";
      this._fetchSensorsCustomWhiteFetchPromise = new Promise((resolve) => {
        (token ? Promise.resolve(token) : this._getUserInfo().then((data) => data ? data.user.token : "")).then((_token) => {
          if (!_token) {
            return resolve(void 0);
          }
          this._http.get(`//yiapp${pre}.xinli001.com/sensors/customWhite?token=${_token}`).then((res) => {
            resolve(res);
          });
        });
      });
    }
    return this._fetchSensorsCustomWhiteFetchPromise;
  }
  _fetchSensorsCustomWhite(obj, token) {
    return new Promise((resolve) => {
      this._fetchSensorsCustomWhiteCache(token).then((res) => {
        const { code, data } = res.data;
        if (code === 0) {
          const target = data.find((v) => v.testName === obj.param_name);
          let testValue = target.testValue;
          if (obj.value_type === "Number") {
            testValue = +testValue;
          } else if (obj.value_type === "Boolean") {
            testValue = Boolean(testValue);
          } else if (obj.value_type === "Object") {
            try {
              testValue = JSON.parse(testValue);
            } catch (e) {
              console.log(e);
              testValue = target.testValue;
            }
          }
          return testValue ? resolve(testValue) : resolve(obj.default_value);
        }
        resolve(void 0);
      }).catch(() => {
        resolve(void 0);
      });
    });
  }
  fetchAbtest(obj, token = "", cache = true) {
    return new Promise((resolve) => {
      const callback = (result) => {
        if (typeof obj.callback === "function")
          obj.callback(result);
        resolve(result);
      };
      console.log(`\u795E\u7B56\u73AF\u5883\u662F\u5426\u652F\u6301ab test`, this.isEnable);
      if (this.isEnable) {
        this._fetchSensorsCustomWhite(obj, token).then((result) => {
          console.log(`\u58F9\u5FC3\u7406\u8FD4\u56DEabtest\u7ED3\u679C`, result);
          return result !== void 0 ? callback(result) : this.loadAbTest().then(() => {
            this._abtest[cache ? "fastFetchABTest" : "asyncFetchABTest"](__spreadProps(__spreadValues({}, obj), {
              callback
            }));
          });
        });
      } else {
        callback(obj.default_value);
      }
    });
  }
  startHeatMap(params, autoTrackeParams) {
    this._startHeatMap(
      typeof params === "object" ? params : {
        click: true,
        stay: true
      }
    );
    this.loadJSPromise.then(() => {
      window.sensors.quick("autoTrack", autoTrackeParams || {});
    });
  }
  stopHeatMap() {
    this.isCollectWebClick = false;
    this.isCollectWebStay = false;
  }
  _startHeatMap(params) {
    if (params.click) {
      this.isCollectWebClick = true;
    }
    if (params.stay) {
      this.isCollectWebStay = true;
    }
  }
}
function singleton() {
  let instance;
  return function(config) {
    if (instance) {
      return instance;
    }
    return instance = new Track(config);
  };
}
const _track = singleton();
const programTypes = {
  "zixun.yuyue": "\u54A8\u8BE2\u5C0F\u7A0B\u5E8F",
  "zixun.qingsu": "\u503E\u8BC9\u5C0F\u7A0B\u5E8F",
  "zixun.toufang": "\u6295\u653E\u5C0F\u7A0B\u5E8F",
  "zixun.xinletu": "\u5FC3\u4E50\u571F\u5C0F\u7A0B\u5E8F",
  yixinli: "\u58F9\u5FC3\u7406\u5C0F\u7A0B\u5E8F"
};
function merge(Vue) {
  Vue.prototype.$handleTrackQuery = function(str) {
    return handleQueryVal(str);
  };
  Vue.prototype.$parseTrackQuery = function(str) {
    return parseQueryVal(str);
  };
  Vue.prototype.$getTrackRunWithRouteQuerys = function(params = {}) {
    const { meta, query } = this.$route;
    const result = {};
    if (meta && meta.pageName) {
      result._source_page_ = meta.pageName;
      if (event) {
        let target = event.target;
        let site = "";
        try {
          let runTimes = 0;
          while (target !== document.documentElement && runTimes < 100) {
            const _site = target.getAttribute("data-site");
            if (_site) {
              site = _site + (site ? "-" : "") + site;
            }
            target = target.parentNode;
            runTimes++;
          }
        } catch (e) {
          console.log(e);
          site = "";
        }
        if (site) {
          result._touch_name_ = site;
        }
      }
    }
    if (query.yxl_source) {
      result.yxl_source = query.yxl_source;
    }
    if (params._source_page_) {
      result._source_page_ = params._source_page_;
    }
    if (params._source_page_) {
      result._touch_name_ = params._touch_name_;
    }
    if (result._source_page_) {
      result._source_page_ = handleQueryVal(result._source_page_);
    }
    if (result._touch_name_) {
      result._touch_name_ = handleQueryVal(result._touch_name_);
    }
    return result;
  };
  Vue.prototype.$trackPageView = function(name, properties = {}) {
    const source_page = properties.source_page || this.$route.query._source_page_ || getQueryString$1("_source_page_") || "";
    const touch_name = properties.touch_name || this.$route.query._touch_name_ || getQueryString$1("_touch_name_") || "";
    const yxl_source = this.$route.query.yxl_source || getQueryString$1("yxl_source") || "";
    const programType = properties.app_name || this.$route.query.programType || getQueryString$1("programType") || "";
    if ((isWxAppWebview() || isAliPayWebview()) && programType) {
      properties.$app_name = programTypes[programType] || parseQueryVal(programType) || "";
    }
    this.$track.send(name, __spreadProps(__spreadValues({
      yxl_source
    }, properties), {
      source_page: source_page ? parseQueryVal(source_page) : "",
      touch_name: touch_name ? parseQueryVal(touch_name) : ""
    }));
  };
  Vue.prototype.$trackEvent = function(name, properties = {}) {
    const yxl_source = this.$route.query.yxl_source || getQueryString$1("yxl_source") || "";
    const programType = properties.app_name || this.$route.query.programType || getQueryString$1("programType") || "";
    if ((isWxAppWebview() || isAliPayWebview()) && programType) {
      properties.$app_name = programTypes[programType] || parseQueryVal(programType) || "";
    }
    this.$track.send(name, __spreadValues({ yxl_source }, properties));
  };
}
const trackPlugin = {
  install(Vue, options) {
    const trackOptions = options && options.trackOptions ? options.trackOptions : void 0;
    const _track$1 = _track(trackOptions);
    Vue.prototype.$track = _track$1;
    if (!window.yxl) {
      window.yxl = {};
    }
    window.yxl.track = _track$1;
    merge(Vue);
    if (options && options.router) {
      options.router.beforeResolve((to, from, next) => {
        const { meta } = to;
        if (meta && meta.saHeatMapEnable) {
          Vue.prototype.$track.startHeatMap(meta.saHeatMapEnable, meta.autoTrackeParams);
        }
        next();
      });
      options.router.afterEach((to, from) => {
        const { meta } = from;
        if (meta && meta.saHeatMapEnable) {
          Vue.prototype.$track.stopHeatMap(meta.saHeatMapEnable, meta.autoTrackeParams);
        }
      });
    }
    if (options && options.store) {
      options.store.watch(
        () => options.store.state.userinfo,
        (val) => {
          try {
            if (val && val.id) {
              _track$1.login(val.id);
            }
          } catch (e) {
            console.log(`_track.login`, e);
          }
        }
      );
    }
  }
};
const trackPlugin$1 = trackPlugin;
function trackCreator(options = {}) {
  const track = _track(options);
  const handleTrackQuery = handleQueryVal;
  const getTrackRunWithRouteQuerys = (params = {}) => {
    const result = {};
    if (params.source_page) {
      result._source_page_ = handleQueryVal(params.source_page);
    }
    if (params.source_page) {
      result._touch_name_ = handleQueryVal(params.touch_name);
    }
    return result;
  };
  const parseTrackQuery = parseQueryVal;
  const trackPageView = function(name, properties = {}) {
    const source_page = properties.source_page || getQueryString$1("_source_page_") || "";
    const touch_name = properties.touch_name || getQueryString$1("_touch_name_") || "";
    const trackOpts = __spreadProps(__spreadValues({}, properties), {
      source_page: source_page ? parseQueryVal(source_page) : "",
      touch_name: touch_name ? parseQueryVal(touch_name) : ""
    });
    const programType = properties.app_name || getQueryString$1("programType") || "";
    if ((isWxAppWebview() || isAliPayWebview()) && programType) {
      trackOpts.$app_name = programTypes[programType] || parseQueryVal(programType) || "";
    }
    track.send(name, trackOpts);
  };
  const trackEvent = function(name, properties = {}) {
    const programType = properties.app_name || getQueryString$1("programType") || "";
    if ((isWxAppWebview() || isAliPayWebview()) && programType) {
      properties.$app_name = programTypes[programType] || parseQueryVal(programType) || "";
    }
    track.send(name, properties);
  };
  return {
    handleTrackQuery,
    parseTrackQuery,
    trackPageView,
    trackEvent,
    getTrackRunWithRouteQuerys
  };
}
const trackLoginAxiosInterceptor = (track) => {
  let logined = false;
  return (res) => {
    if (logined)
      return res;
    const isFetchSuccess = +res.data.code === 0;
    const isFetchUserInfo = res.config.url.indexOf("ajax/get-user-header") > -1;
    if (isFetchUserInfo && isFetchSuccess) {
      const { user } = res.data.data;
      if (user.id) {
        track.login(user.id);
        logined = true;
        console.log(`isFetchUserInfo`, user.id);
      }
    }
    const isFetchConsultUser = res.config.url.indexOf("consult/consult_user");
    if (isFetchConsultUser && isFetchSuccess) {
      const { user_id } = res.data.data;
      track.login(user_id);
      logined = true;
      console.log(`isFetchConsultUser`, user_id);
    }
    return res;
  };
};
const trackLoginAxiosInterceptor$1 = trackLoginAxiosInterceptor;
function hasClass(el, cls) {
  return el.className && new RegExp(`(^|\\s)${cls}(\\s|$)`).test(el.className);
}
function addClass(el, cls) {
  if (!hasClass(el, cls)) {
    const className = el.className;
    el.className += className ? ` ${cls}` : cls;
  }
}
function removeClass(el, cls) {
  const reg = new RegExp(`(\\s|^)${cls}(\\s|$)`);
  el.className = el.className.replace(reg, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function toggleClass(el, cls) {
  if (hasClass(el, cls)) {
    removeClass(el, cls);
  } else {
    addClass(el, cls);
  }
}
function getOffsetTop(el) {
  let actualTop = el.offsetTop;
  let current = el.offsetParent;
  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }
  return actualTop;
}
function stopScroll() {
  if (getComputedStyle(document.body).position === "absolute")
    return;
  const top = document.body.scrollTop || document.documentElement.scrollTop;
  const historyStyle = document.body.style.cssText;
  const styles = {
    position: "absolute",
    width: "10rem",
    left: "50%",
    overflow: "hidden",
    "margin-left": "-5rem",
    "-ms-transform": "none",
    transform: "none"
  };
  const styleText = Object.keys(styles).reduce((all, key) => `${all}${key}:${styles[key]};`, "");
  document.body.style.cssText = styleText;
  document.body.setAttribute("data-stop-scroll", true);
  document.body.setAttribute("data-stop-scroll-his-style", historyStyle);
  document.body.setAttribute("data-stop-scroll-top", top);
}
function recoverScroll() {
  if (getComputedStyle(document.body).position === "absolute" && document.body.hasAttribute("data-stop-scroll")) {
    const historyStyle = document.body.getAttribute("data-stop-scroll-his-style") || "";
    const top = document.body.getAttribute("data-stop-scroll-top") || "";
    document.body.style.cssText = historyStyle;
    if (top) {
      window.scrollTo(0, top);
    }
    document.body.removeAttribute("data-stop-scroll");
  }
}
function dataURLtoBlob(dataurl) {
  let arr = dataurl.split(","), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
function baseStopScroll() {
  const top = document.body.scrollTop || document.documentElement.scrollTop;
  document.body.style.width = "100%";
  document.body.style.position = "fixed";
  document.body.style.top = `${-1 * top}px`;
}
function baseRecoverScroll() {
  const top = -parseInt(document.body.style.top);
  document.body.style.position = "static";
  document.body.style.top = 0;
  window.scrollTo(0, top);
}
function parseDom(html) {
  const ele = document.createElement("div");
  ele.innerHTML = html;
  return ele.childNodes[0];
}
function getScrollTop() {
  const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
  return scrollTop;
}
function setScrollTop(number) {
  if (number !== void 0 && !Number.isNaN(number)) {
    console.log("setScrollTop", number);
    document.body.scrollTop = document.documentElement.scrollTop = window.pageYOffset = number;
  }
}
function getScrollHeight() {
  return document.documentElement.scrollHeight;
}
const dateFormat = (dateObj, fmt) => {
  if (dateObj instanceof Date) {
    console.log("dateObj is good");
  } else if (typeof dateObj == "string") {
    dateObj = new Date(dateObj.replace(/-/g, "/"));
  } else {
    console.error("\u65E5\u671F\u6570\u636E\u683C\u5F0F\u9519\u8BEF");
    return;
  }
  const o = {
    "M+": dateObj.getMonth() + 1,
    "D+": dateObj.getDate(),
    "h+": dateObj.getHours(),
    "m+": dateObj.getMinutes(),
    "s+": dateObj.getSeconds(),
    "q+": Math.floor((dateObj.getMonth() + 3) / 3),
    S: dateObj.getMilliseconds()
  };
  if (/(Y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, `${dateObj.getFullYear()}`.substr(4 - RegExp.$1.length));
  for (const k in o)
    if (new RegExp(`(${k})`).test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
      );
  return fmt;
};
export {
  Bridge,
  addClass,
  addQueryToUrl$1 as addQueryToUrl,
  addUrlParams,
  axiosMock,
  baiduStat,
  baseRecoverScroll,
  baseStopScroll,
  broswerLoadedToDownloadApp$1 as broswerLoadedToDownloadApp,
  chunkArray$1 as chunkArray,
  createHttpServer$1 as createHttpServer,
  dataURLtoBlob,
  dateFormat,
  debounce,
  delCookie,
  getCookie,
  getEnvHost,
  getOffsetTop,
  getPlatform,
  getQueryString$1 as getQueryString,
  getRequestSign,
  getRunningEnv,
  getScrollHeight,
  getScrollTop,
  getStatusBarHeight$1 as getStatusBarHeight,
  getUrlParams,
  handleExpiresStorage$1 as handleExpiresStorage,
  hasClass,
  isCanHideNavigationBar$1 as isCanHideNavigationBar,
  isDangerUrl$1 as isDangerUrl,
  isIOS9,
  isSpider$1 as isSpider,
  loadScript,
  loadStyle,
  omit,
  parseDom,
  pick,
  recoverScroll,
  removeClass,
  setCookie,
  setScrollTop,
  sortByRule$1 as sortByRule,
  stopScroll,
  throttle,
  toggleClass,
  _track as track,
  trackCreator,
  trackLoginAxiosInterceptor$1 as trackLoginAxiosInterceptor,
  trackPlugin$1 as trackPlugin,
  uniq,
  updateQueryStringParameter$1 as updateQueryStringParameter,
  versionfunegt$1 as versionfunegt,
  wxConfigOrigin$1 as wxConfigOrigin
};
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@yxl/libs/lib/index.es.js
// module id = GCHa
// module chunks = 0